import React, {useState, useEffect} from "react";
import { CreateCareerLevel } from './Forms/CreateIDatas'
import { EditCareerLevel } from './Forms/EditDatas'
import axios from 'axios' 
import {Button, Modal} from 'react-bootstrap';
import moment from 'moment'
import { toast, Slide } from 'react-toastify'
import Paginating from "../pagination"
import 'react-toastify/dist/ReactToastify.css';
import  { useAuths }  from '../AuthContext';
const url = process.env.REACT_APP_SERVER_URL






export default function Career() {
const [createCareerLevelModal, setCreateCareerLevelModal] = useState(false)
const [editCareerLevelModal, setEditCareerLevelModal] = useState(false)
const [deleteModal, setDeleteModal] = useState(false)
const [career_text, set_career_text] = useState("")
const [career_id, set_career_id] = useState("")
const {experienceLevel, state} = useAuths()

const [currentPage, setCurrentPage] = React.useState(1)
const [dataPerPage] = React.useState(5)

const indexOfLastPost = currentPage * dataPerPage;
const indexOfFirstPage = indexOfLastPost - dataPerPage;
const currentData = state.career_levels.slice(indexOfFirstPage, indexOfLastPost);


const paginate = (pageNumber) => {
  setCurrentPage(pageNumber)
}
const previousPage = () => {
  if(currentPage - 1 > 0){
    setCurrentPage(currentPage - 1)
  }
}
const nextPage = (dataNumber) => {
  if(currentPage + 1 <= dataNumber){
    setCurrentPage(currentPage + 1)
  }
}

    
const delete_career_level_success = () => {
    toast.success('Career Level Deleted Successfully', {position: toast.POSITION.TOP_RIGHT, theme: "colored", transition: Slide,  hideProgressBar: true})
  }

const delete_career_level_error = () => {
    toast.error('Could Not Delete Career Level, Please Try Again', {position: toast.POSITION.TOP_RIGHT, theme: "colored", transition: Slide,  hideProgressBar: true})
  }
    
    useEffect(() => {
        let mounted = true
        if(mounted){
           experienceLevel(5)
        }
        return() => {
            mounted = false
        }
    }, [])

    function CreateCareerLevelModal(props) {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title  id="contained-modal-title-vcenter">
         <h5>Add Career Level</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
    <CreateCareerLevel />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function EditCareerLevelModal(props) {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title  id="contained-modal-title-vcenter">
         <h5>Edit Career Level</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
    <EditCareerLevel careerText={career_text} careerId={career_id} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function DeleteCareerLevelModal(props) {
  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      bg="transparent"
    >
      <Modal.Body style={{backgroundColor: "#f2edf3"}}>
          <div className="text-center m-3 h6">Are you sure you want to delete Career Level?. <br/>Note: This action is not reversable </div>
        <div className="row justify-content-space-between m-3">
    <Button block onClick={(e) => {deleteCareerLevel(e)}} className="btn btn-danger">Confirm</Button>
    <Button block onClick={() => setDeleteModal(false)} className="btn btn-primary">Cancel</Button>
    </div>
      </Modal.Body>
    </Modal>
  );
}

const deleteCareerLevel = (e) => {
    const token = localStorage.getItem('token')
    e.preventDefault();
    axios.delete(`${url}delete-career-level/${career_id}`, {headers: {
                'Authorization': `Bearer ${token}`
            }}).then(res => {
        delete_career_level_success()
        experienceLevel(e)
        setDeleteModal(false)
    }).catch(err => {
        delete_career_level_error()
    })
}

    return(
      <div className="col-xs-6 col-sm-6 mb-14">
      <div className=" bg-white shadow-8 pt-7 rounded pb-8 px-11 ">
        <div className="row mb-11 align-items-center">
            <div className="col-lg-6 mb-lg-0 mb-4">
              <h3 className="font-size-6 mb-0">Career Level</h3>
            </div>
            <div className="col-lg-6">
              <div className="d-flex flex-wrap align-items-center justify-content-lg-end">
                    <button onClick={e => {e.preventDefault(); setCreateCareerLevelModal(true)}} className="btn btn-green">+ Add Career Level</button>
              </div>
            </div>
          </div>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col" className="border-0 font-size-4 font-weight-normal">Level</th>
                <th scope="col" className="border-0 font-size-4 font-weight-normal">Created on</th>
                <th scope="col" className="border-0 font-size-4 font-weight-normal">Action</th>
                <th scope="col" className="border-0 font-size-4 font-weight-normal"></th>
              </tr>
            </thead>
            <tbody>
     {currentData.map(i => (<tr className="border border-color-2">
              <td className="table-y-middle py-7 min-width-px-110 pr-0">
                <h3 className="font-size-4 font-weight-normal text-black-2 mb-0">{i.title}</h3>
              </td>
              <td className="table-y-middle py-7 min-width-px-110 pr-0">
                <h3 className="font-size-4 font-weight-normal text-black-2 mb-0">{moment(new Date(i.createdAt)).format("MMMM Do YYYY")}</h3>
              </td>
              <td className="table-y-middle py-7 min-width-px-60 pr-0">
                      <div className=""><a href="" onClick={e => {e.preventDefault(); set_career_text(i.title); set_career_id(i._id); setEditCareerLevelModal(true)}} className="font-size-3 font-weight-bold text-green text-uppercase">Edit</a></div>
                    </td>
                    <td className="table-y-middle py-7 min-width-px-70 pr-0">
                      <div className=""><a href="" onClick={e => {e.preventDefault(); set_career_id(i._id); setDeleteModal(true)}} className="font-size-3 font-weight-bold text-red-2 text-uppercase">Delete</a></div>
                    </td>
              </tr>))}
            </tbody>
          </table>
        </div>
        <CreateCareerLevelModal
        show={createCareerLevelModal}
        onHide={() => setCreateCareerLevelModal(false)}
      />
      <EditCareerLevelModal
        show={editCareerLevelModal}
        onHide={() => setEditCareerLevelModal(false)}
      /><DeleteCareerLevelModal
        show={deleteModal}
        onHide={() =>{setDeleteModal(false); set_career_id("")}}
      />
         <div className="">
                 <Paginating dataPerPage={dataPerPage} totalData={state.career_levels.length} paginate={paginate} currentPage={currentPage} nextPage={nextPage} previousPage={previousPage} />
              
            </div>
      </div>
      </div>
    )
}